'use strict';

var utilities = Object.freeze({
        HOT_WATER: 'HOT_WATER',
        COLD_WATER: 'COLD_WATER',
        WATER: 'WATER',
        HEAT: 'HEAT',
        COOL: 'COOL',
        ELECTRICITY: 'ELECTRICITY'
    });

define('shared/utilities/defs/utilities', [], function () {
    return utilities;
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/utilities/defs/utilities.js
// module id = 10
// module chunks = 0 1